<template>
  <VDialog
    width="355"
    persistent
    outlined
    :value="isPaymentDialogOpen"
  >
    <VCard v-if="isPaymentDialogOpen">
      <VCardTitle class="payment-header-container d-block">
        <div class="d-flex flex-column">
          <div class="position-relative d-flex justify-content-between align-items-center">
            <span class="heading-6">
              {{ $t('checkout.paymentForm.payOnline') }}
            </span>
            <VBtn
              class="close-icon"
              icon
              data-test="close-payment-dialog"
              @click="$emit('closePaymentDialog')"
            >
              <VIcon>mdi-close</VIcon>
            </VBtn>
          </div>
          <div class="d-flex flex-column mt-2">
            <div class="d-flex justify-content-between">
              <span class="body-2">
                {{ $t('checkout.paymentForm.totalPrice') }}
              </span>
              <span class="body-2">
                € {{ paymentInfo.totalPrice }}
              </span>
            </div>
          </div>
        </div>
      </VCardTitle>
      <VCardText>
        <PaymentForm
          v-if="getIsBraintree"
          class="mt-4"
          :amount="paymentInfo.totalPrice"
          :authKey="paymentInfo.clientToken"
          :googleMerchantId="paymentInfo.merchantAccountId"
          @onPaymentSuccess="data => $emit('onPaymentSuccess', data)"
          @trackGtmEventPayButtonClick="$emit('trackGtmEventPayButtonClick')"
        />
        <StripeForm
          v-else
          :clientSecret="paymentInfo.stripePaymentSecret.clientSecret"
          :publishableKey="paymentInfo.stripePaymentSecret.publishableKey"
          :setupIntentId="paymentInfo.stripePaymentSecret.setupIntentId"
          :stripeAccount="paymentInfo.stripePaymentSecret.stripeAccount"
          :amount="paymentInfo.totalPrice"
          @trackGtmEventPayButtonClick="$emit('trackGtmEventPayButtonClick')"
          @onPaymentSuccess="data => $emit('onPaymentSuccess', data)"
        />
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script lang="ts">
export default {
  name: 'SPaymentDialog',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import PaymentForm from '@slg/web-customer-shared/src/components/checkout/paymentDialog/PaymentForm.vue';
import PaymentTypeEnum from '@slg/web-customer-shared/src/enum/PaymentTypeEnum';
import StripeForm from './StripeForm.vue';

const props = defineProps({
  isPaymentDialogOpen: {
    type: Boolean,
    default: false,
  },
  paymentInfo: {
    type: Object,
    default: () => ({}),
  },
  paymentType: {
    type: String,
    default: null,
  },
});

const getIsBraintree = computed(() => props.paymentType === PaymentTypeEnum.PRE_PAID);
</script>

<style scoped lang="scss">
.close-icon {
  background: #ffffff50;
  margin-right: -10px;
}
.payment-header-container {
  border-bottom: 1px solid #f1f1f1;
}
</style>
